import { requests } from "../config";
import { IProductWithCounItem } from "./models/productsWithCount";
import { ProductCreatePayload, ProductUpdatePayload } from "../../../main/second/mainbar/tabels/product/types/productTable.types";
import { IGeneralProductId } from "./models/generalProductId";
import { IProductGroupsResponse } from "./models/productGroup";

export const Product = {
    getSizes: () => requests.get(`size`, "node"),
    getProductListWithConts: (date: string): Promise<IProductWithCounItem[]> => requests.get(`product/with_counts?Date=${date}`, "go"),
    getSizesByProduct: (productID: number | string) => requests.get(`product/${productID}/sizes`, "go"),
    getProductList: () => requests.get('product', 'node'),
    getProductGroups: (): Promise<IProductGroupsResponse> => requests.get('product/group', 'node'),
    createProduct: (payload: ProductCreatePayload) => requests.post('product', 'node', payload),
    updateProduct: (id: number, payload: ProductUpdatePayload) => requests.put(`product/${id}`, 'node', payload),
    deleteProduct: (id: number) => requests.delete(`product/${id}`, 'node'),
    getGeneralProductIdList: (): Promise<IGeneralProductId[]> => requests.get(`tbl/Tbl_Products_MainTable`, "go"),
}